import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getConceptoRetencion = async () => {
    const respuesta = PrivateInterceptor('Finanzas/Retencion/ConceptoRetencion', 'GET')
    return respuesta
};

export const GuardarConcepto = (Datos) => {
    const respuesta = PrivateInterceptor("Finanzas/Retencion/ConceptoRetencion/GuardarConcepto", "POST", Datos);
    return respuesta;
};

export const EditarConcepto = (Datos) => {
    const respuesta = PrivateInterceptor("Finanzas/Retencion/ConceptoRetencion/EditarConcepto", "POST", Datos);
    return respuesta;
};


export const getCuentasHijas = async () => {
    const respuesta = PrivateInterceptor('Finanzas/Retencion/ConceptoRetencion/CuentasHijas', 'GET')
    return respuesta
};

export const traducir = async (texto) => {
    const response = await fetch(`https://www.apertium.org/apy/translate?langpair=es|en&q=${encodeURIComponent(texto)}`, {
        method: "GET",
      });
    
      const data = await response.json();
      return data.responseData.translatedText;
  };
  